import React from "react";
import { MapProvider, useMapSelection } from "./contexts/MapContext";
import { PinProvider } from "./contexts/PinContext";
import MapSelector from "./components/MapSelector";
import Map from "./components/Map";
import { UI_CONFIG } from "./constants";

/**
 * マップセレクター と マップを統合したコンテンツコンポーネント
 */
const MapContent: React.FC = () => {
  const { selectedMap, setSelectedMap, availableMaps } = useMapSelection();

  return (
    <div>
      <MapSelector
        selectedMap={selectedMap}
        availableMaps={availableMaps}
        onSelectMap={setSelectedMap}
      />
      <PinProvider mapId={selectedMap}>
        <Map mapSrc={selectedMap} />
      </PinProvider>
    </div>
  );
};

/**
 * メインアプリケーション
 */
function App() {
  return (
    <MapProvider>
      <MapContent />
    </MapProvider>
  );
}

export default App;
